import { CssStates, embeddedImagesBase64, IGrapesJSProjectData, SmartIdentifierStates } from "../../../interfaces/VisageUI";
import { GjsAttributeNames } from "../gjsplugin/Enums";

const GjsTemplateIntro: IGrapesJSProjectData = {
	"assets":[

	],
	"styles":[
		{
			"selectors":[

			],
			"selectorsAdd":"body",
			"style":{
				"width":"100vw",
				"height":"100vh",
				"background-color":"transparent"
			}
		},
		{
			"selectors":[
				"gjs-plh-image"
			],
			"style":{
				"background-image":"none",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial",
				"outline-color":"initial",
				"outline-style":"none",
				"outline-width":"initial"
			}
		},
		{
			"selectors":[
				"#Cf3d3d78b-3ad4-4afd-a1b7-b2fe41d9c616"
			],
			"style":{
				"width":"100%",
				"flex-direction":"column",
				"height":"100%",
				"display":"flex",
				"justify-content":"center",
				"align-items":"center"
			}
		},
		{
			"selectors":[
				"Btn_SecondaryCTA"
			],
			"style":{
				"__background-type":"grad",
				"background-repeat":"repeat",
				"background-position":"left top",
				"background-attachment":"scroll",
				"background-size":"auto",
				"background-image":"linear-gradient(to top, #b4b4b4 86%, #d5d5d5 100%)",
				"position":"relative",
				"margin":"0vw 0.5vw 0vw 0vw",
				"width":"20vw"
			}
		},
		{
			"selectors":[
				"Btn_Primary_CTA"
			],
			"style":{
				"position":"relative",
				"width":"20vw"
			}
		},
		{
			"selectors":[
				{
					"name":"Btn_SecondaryTest",
					"active":false
				}
			],
			"style":{
				"width":"20vw",
				"border":"0vw none black"
			}
		},
		{
			"selectors":[
				"#C0df669d1-6c9d-4ed3-a74b-fe9f5f083d58"
			],
			"style":{
				"height":"36vw",
				"background":"rgba(30,30,30,0.8)",
				"flex-direction":"row",
				"box-shadow":"0vw 0vw 2vw 0vw rgba(30,30,30,0.8) ",
				"min-width":"70vw",
				"width":"70vw",
				"display":"flex",
				"border-top-left-radius":"1vw",
				"border-top-right-radius":"1vw",
				"border-bottom-right-radius":"1vw",
				"border-bottom-left-radius":"1vw"
			}
		},
		{
			"selectors":[
				"#C0df669d1-6c9d-4ed3-a74b-fe9f5f083d58-2"
			],
			"style":{
				"width":"50%",
				"display":"flex",
				"flex-direction":"column",
				"padding-left":"1.5vw",
				"padding-top":"1.5vw",
				"padding-right":"1.5vw",
				"padding-bottom":"1.5vw"
			}
		},
		{
			"selectors":[
				"#C0df669d1-6c9d-4ed3-a74b-fe9f5f083d58-3"
			],
			"style":{
				"width":"50%",
				"__background-type":"grad",
				"background-repeat":"repeat",
				"background-position":"left top",
				"background-attachment":"scroll",
				"background-size":"auto",
				"background-image":"linear-gradient(to top, #454545 0%, #6a6a6a 100%)",
				"position":"relative",
				"display":"flex",
				"border-top-left-radius":"1vw",
				"border-top-right-radius":"0vw",
				"border-bottom-right-radius":"0vw",
				"border-bottom-left-radius":"1vw",
				"flex-direction":"column",
				"justify-content":"center",
				"align-items":"center"
			}
		},
		{
			"selectors":[
				"#Caaefb8d9-0fd5-4b9d-abc8-fa58a1f8720d"
			],
			"style":{
				"height":"90%",
				"width":"90%",
				"position":"relative"
			}
		},
		{
			"selectors":[
				"#C8ffbe533-2d95-4f6a-861a-19a9ca21b7b0"
			],
			"style":{
				"font-family":"Arial, Helvetica, sans-serif",
				"font-size":"2.5vw",
				"font-weight":"700",
				"color":"#ebebeb",
				"width":"100%"
			}
		},
		{
			"selectors":[
				"#C8e22a94e-20db-4d49-a07f-fcd0091b2fce-2"
			],
			"style":{
				"white-space-collapse":"preserve",
				"font-size":"2vw",
				"font-family":"Arial, Helvetica, sans-serif",
				"color":"#ebebeb",
				"margin-top":"1vw",
				"margin-bottom":"1vw",
				"margin-left":"0vw",
				"margin-right":"0vw",
				"width":"100%",
				"height":"100%"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"*",
			"style":{
				"font-family":"Roboto, Arial, sans-serif"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"::-webkit-scrollbar",
			"style":{
				"width":"10px",
				"height":"10px"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"::-webkit-scrollbar-track",
			"style":{
				"background-color":"rgb(51, 51, 51)"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"::-webkit-scrollbar-corner",
			"style":{
				"background-color":"rgb(51, 51, 51)"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"::-webkit-scrollbar-thumb",
			"style":{
				"background-color":"rgb(191, 191, 191)"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"::-webkit-scrollbar-thumb:hover",
			"style":{
				"background-color":"rgb(235, 235, 235)"
			}
		},
		{
			"selectors":[
				"primary-cta"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"20vw",
				"height":"4.5vw",
				"min-height":"4.5vw",
				"border-top-left-radius":"12vw",
				"border-top-right-radius":"12vw",
				"border-bottom-right-radius":"12vw",
				"border-bottom-left-radius":"12vw",
				"background-image":"linear-gradient(rgb(255, 255, 255) 0%, rgb(239, 239, 239) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial",
				"color":"rgb(48, 48, 48)",
				"font-size":"2vw",
				"box-shadow":"rgba(0, 0, 0, 0.4) 0px 0px 1vw 0px"
			}
		},
		{
			"selectors":[
				"primary-cta"
			],
			"style":{
				"transform":"scale(1.05, 1.05)"
			},
			"state":CssStates.Hover
		},
		{
			"selectors":[
				"primary-cta"
			],
			"style":{
				"background-image":"linear-gradient(rgb(255, 255, 255) 0%, rgb(239, 239, 239) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial"
			},
			"state":CssStates.Active
		},
		{
			"selectors":[
				"secondary-cta"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"20vw",
				"height":"4.5vw",
				"min-height":"4.5vw",
				"border-top-left-radius":"12vw",
				"border-top-right-radius":"12vw",
				"border-bottom-right-radius":"12vw",
				"border-bottom-left-radius":"12vw",
				"background-image":"linear-gradient(rgb(118, 118, 118) 0%, rgb(79, 79, 79) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial",
				"color":"rgb(235, 235, 235)",
				"font-size":"2vw",
				"box-shadow":"rgba(0, 0, 0, 0.4) 0px 0px 1vw 0px"
			}
		},
		{
			"selectors":[
				"secondary-cta"
			],
			"style":{
				"transform":"scale(1.05, 1.05)"
			},
			"state":CssStates.Hover
		},
		{
			"selectors":[
				"secondary-cta"
			],
			"style":{
				"background-image":"linear-gradient(rgb(164, 164, 164) 0%, rgb(126, 126, 126) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial"
			},
			"state":CssStates.Active
		},
		{
			"selectors":[
				"primary-icon-cta"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"9vw",
				"height":"9vw",
				"background-color":"rgba(30, 30, 30, 0.8)",
				"border-top-left-radius":"50%",
				"border-top-right-radius":"50%",
				"border-bottom-right-radius":"50%",
				"border-bottom-left-radius":"50%"
			}
		},
		{
			"selectors":[
				"primary-icon-cta"
			],
			"style":{
				"transform":"scale(1.05, 1.05)"
			},
			"state":CssStates.Hover
		},
		{
			"selectors":[
				"primary-icon-cta"
			],
			"style":{
				"background-color":"rgb(89, 89, 89)"
			},
			"state":CssStates.Active
		},
		{
			"selectors":[
				"secondary-icon-cta"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"7.25vw",
				"height":"7.25vw",
				"background-color":"rgba(30, 30, 30, 0.8)",
				"border-top-left-radius":"50%",
				"border-top-right-radius":"50%",
				"border-bottom-right-radius":"50%",
				"border-bottom-left-radius":"50%"
			}
		},
		{
			"selectors":[
				"secondary-icon-cta"
			],
			"style":{
				"transform":"scale(1.05, 1.05)"
			},
			"state":CssStates.Hover
		},
		{
			"selectors":[
				"secondary-icon-cta"
			],
			"style":{
				"background-color":"rgb(89, 89, 89)"
			},
			"state":CssStates.Active
		},
		{
			"selectors":[
				"#C99708fde-3baa-415d-986e-dc22acac3db0"
			],
			"style":{
				"width":"90%",
				"height":"auto",
				"font-size":"2vw",
				"font-weight":"normal",
				"color":"#EBEBEB",
				"text-align":"left"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"div[data-gjs-type=\"wrapper\"]",
			"style":{
				"height":"100vh",
				"width":"100vw"
			}
		},
		{
			"selectors":[
				"visageEditorDefaultContainer"
			],
			"style":{
				"position":"relative",
				"width":"100%",
				"height":"100%",
				"display":"flex",
				"align-items":"center",
				"justify-content":"center"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"text",
			"style":{
				"display":"inline-block",
				"min-width":"1vw",
				"min-height":"1vw"
			}
		},
		{
			"selectors":[
				"#C699e8cbb-19c1-411b-a8a0-2c5b6c677491"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"100%",
				"height":"4.5vw",
				"min-height":"4.5vw",
				"border-top-left-radius":"12vw",
				"border-top-right-radius":"12vw",
				"border-bottom-right-radius":"12vw",
				"border-bottom-left-radius":"12vw",
				"background-image":"linear-gradient(rgb(255, 255, 255) 0%, rgb(239, 239, 239) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial",
				"color":"rgb(48, 48, 48)",
				"font-size":"2vw",
				"box-shadow":"rgba(0, 0, 0, 0.4) 0px 0px 1vw 0px",
				"background":"linear-gradient(0deg, RGB(197, 197, 197) 0%, rgba(241,241,241,1) 100%)"
			}
		},
		{
			"selectors":[
				"#Cdbcc42f1-b151-420e-974b-dd719860e39a"
			],
			"style":{
				"font-size":"2vw",
				"font-weight":"700",
				"color":"rgba(48, 48, 48, 1)"
			}
		},
		{
			"selectors":[
				"#Cc50d4030-20e6-4d4c-b3bb-b5f24ad0d52d"
			],
			"style":{
				"height":"3vw",
				"font-size":"2vw",
				"font-weight":"normal",
				"color":"#EBEBEB",
				"text-align":"left",
				"position":"absolute",
				"left":"2vw",
				"bottom":"2vw",
				"transform":" ",
				"width":"vw",
				"display":"none"
			}
		}
	],
	"pages":[
		{
			"frames":[
				{
					"component":{
						"type":"wrapper",
						"stylable":[
							"background",
							"background",
							"background-image",
							"background-repeat",
							"background-attachment",
							"background-position",
							"background-size"
						],
						"attributes":{
							"id":"i5rl"
						},
						"components":[
							{
								"type":"div",
								"attributes":{
									"id":"Cf3d3d78b-3ad4-4afd-a1b7-b2fe41d9c616",
									"data-action":"",
									"data-no-actions":"",
									"data-not-deletable":"",
									"data-not-resizable":"",
									"data-not-copiable":""
								},
								"components":[
									{
										"type":"div",
										"attributes":{
											"id":"C0df669d1-6c9d-4ed3-a74b-fe9f5f083d58",
											"data-action":""
										},
										"components":[
											{
												"type":"div",
												"attributes":{
													"id":"C0df669d1-6c9d-4ed3-a74b-fe9f5f083d58-3",
													"data-action":""
												},
												"components":[
													{
														"type":"image",
														"name":"Image",
														"resizable":{
															"ratioDefault":1
														},
														"attributes":{
															"id":"C99708fde-3baa-415d-986e-dc22acac3db0",
															"asset-id":"",
															"src":embeddedImagesBase64.imagePlaceholder,
															"data-action":""
														}
													},
													{
														"type":"image",
														"name":"Image",
														"resizable":{
															"ratioDefault":1
														},
														"attributes":{
															"id":"Cc50d4030-20e6-4d4c-b3bb-b5f24ad0d52d",
															"asset-id":"",
															"src":"",
															"data-action":""
														},
														"custom-name":"Logo"
													}
												],
												"custom-name":"Left Panel",
												"__prev-display":"flex"
											},
											{
												"type":"div",
												"attributes":{
													"id":"C0df669d1-6c9d-4ed3-a74b-fe9f5f083d58-2",
													"data-action":""
												},
												"components":[
													{
														"type":"e-text",
														"content":"Title",
														"attributes":{
															"id":"C8ffbe533-2d95-4f6a-861a-19a9ca21b7b0",
															"data-action":""
														},
														"custom-name":"Title"
													},
													{
														"type":"e-text",
														"content":"Description",
														"attributes":{
															"id":"C8e22a94e-20db-4d49-a07f-fcd0091b2fce-2",
															"data-action":"",
															[GjsAttributeNames.SmartIdentifier]:SmartIdentifierStates.Enabled,
														},
														"custom-name":"Description"
													},
													{
														"type":"div",
														"name":"Primary Button",
														"classes":[
															"primary-cta"
														],
														"attributes":{
															"id":"C699e8cbb-19c1-411b-a8a0-2c5b6c677491",
															"asset-id":""
														},
														"components":[
															{
																"type":"e-text",
																"name":"Label",
																"content":"Begin",
																"attributes":{
																	"id":"Cdbcc42f1-b151-420e-974b-dd719860e39a",
																}
															}
														],
														"custom-name":"Begin Button"
													}
												],
												"custom-name":"Right Panel"
											}
										],
										"custom-name":"Intro Window"
									}
								],
								"custom-name":"Template Container"
							}
						],
						"custom-name":"Intro"
					},
					"id":"oA5LLhXOVbFv0Lk0"
				}
			],
			"type":"main",
			"id":"kOCGgDvnkDAuSz8T"
		}
	]
};

export default GjsTemplateIntro;